module.exports = __webpack_public_path__ + "img/fzlc-3.4b7097db.png";